import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'
import Loadable from '../../base/components/Template/Loadable/Loadable'

const AppVentaRegistro = Loadable(lazy(() => import('./view/VentaRegistro')))
const AppVentaGestion = Loadable(lazy(() => import('./view/VentaGestion')))
const AppVentaRegistroOffline = Loadable(lazy(() => import('./view/VentaRegistroOffline')))
const VentaGestionOffline = Loadable(lazy(() => import('./view/VentaGestionOffline')))

export const ventasRoutesMap = {
  registro: {
    name: 'Registrar Venta',
    path: '/ventas/registro',
  },
  registroOffline: {
    name: 'Registrar Venta Libros Offline',
    path: '/ventas/registro-offline',
  },
  gestion: {
    name: 'Gestión de Ventas',
    path: '/ventas/gestion',
  },
  gestionOffline: {
    name: 'Gestión de Ventas Offline',
    path: '/ventas/gestion-offline',
  },
}

const ventasRoutes = [
  {
    path: ventasRoutesMap.registro.path,
    element: <AppVentaRegistro />,
    auth: authRoles.admin,
  },
  {
    path: ventasRoutesMap.gestion.path,
    element: <AppVentaGestion />,
    auth: authRoles.admin,
  },
  {
    path: ventasRoutesMap.gestionOffline.path,
    element: <VentaGestionOffline />,
    auth: authRoles.admin,
  },
  {
    path: ventasRoutesMap.registroOffline.path,
    element: <AppVentaRegistroOffline />,
    auth: authRoles.admin,
  },
]

export default ventasRoutes
